/* eslint-disable no-undef, no-console */
/**
  Studentbo frontend scripts.
 */

document.addEventListener( 'DOMContentLoaded', function() {
	// Handle FacetWP loaded event
	document.addEventListener( 'facetwp-loaded', function() {
		// Get the selected facet type
		const selected = FWP.facets.type ? FWP.facets.type[ 0 ] : null;

		// Remove the active class from all facets
		document
			.querySelectorAll( '.hb-filter__facets' )
			.forEach( ( facet ) =>
				facet.classList.remove( 'hb-filter__facets--active' )
			);

		// Fallback to "group-6" if nothing is selected
		const targetGroup = selected || 'group-6';

		// Add the active class to the target group
		const targetFacet = document.querySelector(
			`.hb-filter__facets[data-group="${ targetGroup }"]`
		);
		if ( targetFacet ) {
			targetFacet.classList.add( 'hb-filter__facets--active' );
		}

		// Select all "disabled" radio choices inside the "type" facet and remove the class
		const radios = document.querySelectorAll(
			'.facetwp-facet-type .facetwp-radio.disabled'
		);
		radios.forEach( function( radio ) {
			radio.classList.remove( 'disabled' );
		} );
	} );

	// Reset all facets except the "type" facet when a radio button in the "type" facet is clicked
	document.addEventListener( 'click', function( event ) {
		const radio = event.target.closest(
			'.facetwp-facet-type .facetwp-radio'
		);
		if ( radio ) {
			FWP.refresh();
		}
	} );

	// Handle FacetWP refresh event
	document.addEventListener( 'facetwp-refresh', function() {
		const facetName = 'type';
		if (
			null !== FWP.active_facet &&
			facetName === fUtil( FWP.active_facet.nodes[ 0 ] ).attr( 'data-name' )
		) {
			const others = FWP.facets;
			Object.keys( others ).forEach( function( key ) {
				if ( facetName !== key ) {
					FWP.facets[ key ] = [];
				}
			} );
		}
	} );
} );

// Turn object list view desktop table and turn it into mobile card view
( function() {
	const TABLE_SEL = '.object-list__table';
	const TBODY_SEL = '.object-list__body';
	const ROW_SEL = '.object-list__row';
	const CELL_SEL = '.object-list__cell';
	const CARDS_ID = 'object-list-cards';

	function text( el ) {
		return ( el?.textContent || '' ).trim();
	}

	function buildDetailsItem( term, value ) {
		if ( ! value ) {
			return '';
		}
		return `
	<div class="hb-description-list-item-block hb-description-list-item-block--has-divider">
		<dt class="hb-description-list-item-block__term">${ term }</dt>
		<dd class="hb-description-list-item-block__description">${ value }</dd>
	</div>`;
	}

	function buildCardFromRow( row ) {
		const cells = row.querySelectorAll( CELL_SEL );
		if ( ! cells.length ) {
			return '';
		}

		// Expected table columns:
		// 0: Adress, 1: Hus, 2: Typ, 3: Boarea, 4: Våning, 5: Hyra, 6: Tillträde
		const linkEl = cells[ 0 ].querySelector( 'a' );
		const href = linkEl ? linkEl.href : '#';
		const adress = linkEl ? text( linkEl ) : text( cells[ 0 ] );
		const hus = text( cells[ 1 ] );
		const boendetyp = text( cells[ 2 ] );
		const storlek = text( cells[ 3 ] );
		const vaning = text( cells[ 4 ] );
		const hyra = text( cells[ 5 ] );
		const tilltrade = text( cells[ 6 ] );

		const detailsHTML = `
	${ buildDetailsItem( 'Boendetyp', boendetyp ) }
	${ buildDetailsItem( 'Storlek', storlek ) }
	${ buildDetailsItem( 'Våning', vaning ) }
	${ buildDetailsItem( 'Hyra', hyra ) }
	${ buildDetailsItem( 'Tillträde', tilltrade ) }
	`;

		return `
<li class="hb-object-item">
<section class="hb-section-block hb-section-block--content-full-width hb-section-block--bg-color-primary hb-section-block--spacing-small">
	<div class="hb-columns-block hb-columns-block--halves hb-columns-block--spacing-none">
	<div class="hb-group-block hb-group-block--bg-color-vivid-purple-20">
		<div class="hb-object-card__content">
			<h3 class="hb-object-card__heading hb-heading-block hb-heading-block--size-medium">
				<a href="${ href }">
					${ adress }
				</a>
			</h3>
			${ hus ? `<p class="hb-preamble">${ hus }</p>` : '' }
			<!-- No image + no extra description on list view -->
			</div>

			<div class="hb-object-card__details">
			<dl class="hb-description-list-block">
				${ detailsHTML }
			</dl>
		</div>
	</div>
	</div>
</section>
</li>`;
	}

	function buildCards() {
		const table = document.querySelector( TABLE_SEL );
		const tbody = table?.querySelector( TBODY_SEL );
		const cards = document.getElementById( CARDS_ID ) || ( () => {
			const ul = document.createElement( 'ul' );
			ul.id = CARDS_ID;
			ul.className = 'object-list__cards card';
			table?.insertAdjacentElement( 'afterend', ul );
			return ul;
		} )();

		if ( ! tbody || ! cards ) {
			return;
		}

		const rows = Array.from( tbody.querySelectorAll( ROW_SEL ) );
		const html = rows.map( buildCardFromRow ).join( '' );
		cards.innerHTML = html;
	}

	function makeCardsClickable() {
		const cards = document.querySelectorAll( '.hb-object-item' );

		cards.forEach( ( card ) => {
			const link = card.querySelector( 'a' );

			if ( link ) {
				card.addEventListener( 'click', ( event ) => {
					if ( event.defaultPrevented ) {
						return;
					}

					if ( event.target.closest( 'a' ) ) {
						return;
					}

					link.click();
				} );
			}
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', () => {
			buildCards();
			makeCardsClickable();
		} );
	} else {
		buildCards();
		makeCardsClickable();
	}

	window.addEventListener( 'facetwp-loaded', () => {
		buildCards();
		makeCardsClickable();
	} );
}() );
